export const consentTimeoutSeconds = 120;

export const clockSkewToleranceMs = 2_000;

let clockOffsetMs = 0;

export function clockOffset(localMs: number, serverMs: number): number {
  if (!Number.isFinite(localMs) || !Number.isFinite(serverMs)) return 0;
  const delta = serverMs - localMs;
  if (Math.abs(delta) <= clockSkewToleranceMs) return 0;
  return delta;
}

export function noteServerDate(localMs: number, serverHeader: string | null): void {
  if (!serverHeader) return;
  const serverMs = Date.parse(serverHeader);
  clockOffsetMs = clockOffset(localMs, serverMs);
}

export function serverClockOffsetMs(): number {
  return clockOffsetMs;
}

export function correctedNow(localMs: number, offsetMs: number): number {
  return localMs + offsetMs;
}

export function dialogSeconds(nowMs: number, deadlineMs: number, requestedAtMs?: number | null): number {
  if (!Number.isFinite(nowMs) || !Number.isFinite(deadlineMs)) return 0;
  const remainingMs = deadlineMs - nowMs;
  if (remainingMs <= 0) return 0;
  const whole = Math.floor(remainingMs / 1000);
  if (whole < 1) return 0;
  if (requestedAtMs === undefined || requestedAtMs === null || !Number.isFinite(requestedAtMs)) {
    return Math.min(whole, consentTimeoutSeconds);
  }
  const elapsed = nowMs - requestedAtMs;
  const elapsedWhole = elapsed <= 0 ? 0 : Math.floor(elapsed / 1000);
  const fromRequest = consentTimeoutSeconds - elapsedWhole;
  if (fromRequest < 1) return 0;
  return Math.min(fromRequest, whole);
}

export function formatConsentRemaining(secondsRemaining: number): string {
  const seconds = secondsRemaining < 0 || !Number.isFinite(secondsRemaining) ? 0 : Math.floor(secondsRemaining);
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return `${minutes}:${rest.toString().padStart(2, "0")}`;
}

export function consentRemainingLabel(nowMs: number, deadlineAt: string | null, requestedAt?: string | null): string | null {
  if (!deadlineAt) return null;
  const deadlineMs = Date.parse(deadlineAt);
  if (!Number.isFinite(deadlineMs)) return null;
  const requestedMs = requestedAt ? Date.parse(requestedAt) : null;
  const now = correctedNow(nowMs, serverClockOffsetMs());
  return `Time remaining ${formatConsentRemaining(dialogSeconds(now, deadlineMs, requestedMs))}`;
}
